// removed by extract-text-webpack-plugin
module.exports = {"tile":"tile__2aShD","inlineBlock":"inlineBlock__67joQ","tileDescription":"tileDescription__1xssW","tileDescriptionHeader":"tileDescriptionHeader__9UyH5","tileDescriptionContent":"tileDescriptionContent__1B3dt","descriptionFade":"descriptionFade__37tD9","seeMoreWrapper":"seeMoreWrapper__pvo_K","comingSoonContainer":"comingSoonContainer__G0uis","comingSoonContainerCategory":"comingSoonContainerCategory__15Muu","comingSoonPill":"comingSoonPill__3VS32","merchantImage":"merchantImage__19ZqM","card":"card__2uYMn"};


//////////////////
// WEBPACK FOOTER
// ./components/common/merchant/style.css
// module id = 4uKi
// module chunks = 323 333 337 339